import { render, staticRenderFns } from "./prestation.vue?vue&type=template&id=04310700&scoped=true"
import script from "./prestation.vue?vue&type=script&lang=ts&setup=true"
export * from "./prestation.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./prestation.vue?vue&type=style&index=0&id=04310700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04310700",
  null
  
)

export default component.exports